<template>
    <li class="megamenu-links__item" v-if="i <= 4">
        <a href="#" class="megamenu-links__item-link" @click.prevent="categoryClicked(lvl3.DMCD01, lvl3.DMCD02, lvl3.DMCD03)">
        {{ lvl3.categoryname }}
        </a>
    </li>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {
    emit: ['close_menu'],
    props: {
        lvl3 : {
            type: Object,
            required: true
        },
        i: {
            type: Number
        },
        totalsub: {
            type: Number,
            required: true
        }
    },
    methods: {
        categoryClicked(level1, level2, level3) {
      
            // const hasVeh = this.level1.find(l => l.DMCD01 == level1);
            // if (hasVeh.DSVEH == 'Y'){
            //     this.vehicle_category = level1;
            //     this.openDialog = true;
            //     return;
            // }
            
            this.deptDropdown = false;
            this.isloading = true;

            // const url = 'D15PGMLIB/lansaweb?w=category&r=categoryParts&vlweb=1&part=erp&lang=ENG&_T=1611072351543';
            const partslist_uri = this.$store.getters['api/partslist_uri'];
            axiosvl.post(partslist_uri, {
                // parameters
                webroutine: {
                    context: {
                    "session-key-method": "hidden",
                    },
                    fields: {
                        EHCUST: { value: this.$store.getters['customer'] },
                        KL01: { value: level1 },
                        KL02: { value: level2 },
                        KL03: { value: level3 },
                        KL04: { value: "" },
                        KL05: { value: "" },
                        KL06: { value: "" },
                        KL07: { value: "" },
                        KL08: { value: "" },
                        KL09: { value: "" },
                        KL10: { value: "" },
                    },
                },
            })
            .then((response) => {
                this.$emit('close_menu');

                // let currentcategory = '';
                let uri = '';
                let category_uri = '';
                let currentlevel = 0;
                if (level3 != '') {
                    currentlevel = 3;
                } else if (level2 != '') {
                    currentlevel = 2;
                } else {
                    currentlevel = 1;
                }

                if (response.data.webroutine.lists.CPARTS.entries.length > 0) {
                    category_uri = '/sub-category/';
                } else {
                    category_uri = '/category/';
                }

                switch (currentlevel){
                    case 1:
                        // uri = '/category-search/' + level1;
                        uri = category_uri + currentlevel + "/" + level1;
                    break;
                    case 2:
                        uri = category_uri + currentlevel + "/" + level1 + "/" + level2
                    break;
                    case 3:
                        uri = category_uri + currentlevel + "/" + level1 + "/" + level2 + "/" + level3;
                    break;
                }

                let ln = 1;
                while (ln <= currentlevel){
                    const curr_cat = this.fetchCatDetails(ln, level1, level2, level3);
                    uri += '/' + curr_cat.categoryname.replace(/ /g, '-');
                    ln++;
                }
                // console.log(uri);
                this.$router.push(uri);
                // this.isloading = false;
            })
            .catch(function (error) {
                console.log("error - " + error);
                // this.isloading = false;
            });
        },

        fetchCatDetails(level, DMCD01, DMCD02, DMCD03) {
            const st_categories = this.$store.getters['product/categories'];
            // const level = this.category.categorylevel;

            const cat = st_categories.find((cat) => {
                switch (level){
                    case 1:
                        return ((cat.DMCD01 === DMCD01) && (cat.categorylevel === level));
                    case 2:
                        return ((cat.DMCD01 === DMCD01) && (cat.DMCD02 === DMCD02) && (cat.categorylevel === level));
                    case 3:
                        return ((cat.DMCD01 === DMCD01) && (cat.DMCD02 === DMCD02)  && (cat.DMCD03 === DMCD03) && (cat.categorylevel === level));
                }
            });

            return cat;
        },
    }
}
</script>